import Vue from 'vue';

export default new Vue({
  data() {
    return {
      // 错误报表页filter选中的version
      errPageVersion: [],
      // 当前错误type1_list
      currentErrType: '',
      // 用户分群->新建用户分群->用户范围:用户类型
      userRangeType: 'newuser',
      // 用户分群->新建用户分群->用户范围:日期范围
      userRangeDate: [],
      // 质量分析模块变量
      qualityChannelInfo: {},
    };
  },
});
